module.exports = "/_next/static/images/logo-jxl-icon-78dfb78361d5ae407cbb60564f04f2c9.png";